// extracted by mini-css-extract-plugin
export var centerText = "_4e-8";
export var container = "_4e-0";
export var doughnutContainer = "_4e-7";
export var legend = "_4e-a";
export var legendItemColorDisplay = "_4e-b";
export var legendItemLabel = "_4e-d";
export var legendItemValue = "_4e-c";
export var lg = "_4e-5";
export var maxWidth = "_4e-9";
export var md = "_4e-4";
export var responsive = "_4e-6";
export var sm = "_4e-3";
export var xs = "_4e-2";
export var xxs = "_4e-1";